import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qrcode from 'qrcode';
import './style.css';

class QRCode extends Component {
  constructor(props) {
    super(props);
    this.qrContainer = React.createRef();
  }

  componentDidMount() {
    this.renderQrCode();
  }

  renderQrCode() {
    qrcode.toCanvas(this.qrContainer.current, this.props.code, err => {
      console.log(err); // eslint-disable-line no-console
    });
  }

  render() {
    return (
      <div className="qr-code">
        <canvas ref={this.qrContainer} />
      </div>
    );
  }
}

QRCode.propTypes = {
  code: PropTypes.string.isRequired,
};

export default QRCode;
